import * as React from 'react';

import { Icon } from '@/shared/types/icon';

const LiveChat = ({
  size = 24,
  color = '#FF5100',
  ref,
  ...props
}: Icon & { ref?: React.Ref<SVGSVGElement> }) => {
  return (
    <svg
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.5 2h15A2.5 2.5 0 0122 4.5v11a2.5 2.5 0 01-2.5 2.5H10l-5.2 3.9A.5.5 0 014 21.5V18a2 2 0 01-2-2V4.5A2.5 2.5 0 014.5 2z" />
    </svg>
  );
};

export default LiveChat;
